/* ==========================================================================
   PUREPILOT — Theme JavaScript
   Scroll-reveal animations and small interactions.
   ========================================================================== */

(function() {
  'use strict';

  // ============== SCROLL REVEAL ==============
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    function init() {
      document.querySelectorAll('.pp-reveal').forEach(function(el) {
        observer.observe(el);
      });

      // Stagger reveals slightly when in same parent
      document.querySelectorAll('.pp-section, .pp-features, .pp-testimonials, .pp-products, .pp-categories').forEach(function(parent) {
        var items = parent.querySelectorAll('.pp-reveal');
        items.forEach(function(el, i) {
          el.style.transitionDelay = (i * 80) + 'ms';
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  } else {
    // Fallback: just show everything
    document.querySelectorAll('.pp-reveal').forEach(function(el) {
      el.classList.add('in');
    });
  }

  // ============== NEWSLETTER FORM HANDLER ==============
  // Shopify will handle the form post natively; this just adds loading state
  document.addEventListener('submit', function(e) {
    if (e.target.matches('.pp-newsletter form')) {
      var btn = e.target.querySelector('button');
      if (btn) btn.textContent = 'SENDING...';
    }
  });
})();
